

class TDBaseElement extends HTMLElement {
  constructor() {
    super()
    this.MOBILE_MEDIA_QUERY = '(max-width: 1024px)'
    this.CURRENCY = Shopify.currency.active;
    this.LANGUAGE = 'en-US';
    this.MONEY_FORMATTER = new Intl.NumberFormat(this.LANGUAGE, {
      style: 'currency',
      currency: this.CURRENCY,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      currencyDisplay: 'narrowSymbol',
    });

    this.unsubscibeFunctions = []
  }
  disconnectedCallback() {
    this.unsubscibeFunctions.forEach((func) => func())
    this.destroyFunction()
  }
  connectedCallback() {
    setTimeout(() => {
      this.initializationFunction()
    }) 
  }
  initializationFunction() {
    // Stub for initialization cleanup
  }
  destroyFunction() {
    // Stub for disconnected cleanup
  }
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
  checkIsMobile() {
    return window.matchMedia(this.MOBILE_MEDIA_QUERY).matches
  }
  formatMoney(amount) {
    return this.MONEY_FORMATTER.format(amount)
  }
}
customElements.define('td-base-element', TDBaseElement)

// COLLECTION FILTERS
if (!customElements.get('td-byob-filter')) {
  class BundleFilter extends TDBaseElement {

    constructor() {
      super()
      this.FILTER_VALUE = this.dataset.collection
      this.active = this.dataset.active && this.dataset.active != 'false'
    }

    initializationFunction() {
      if (this.FILTER_VALUE) {
        this.attachListeners()
        this.subscribeToEvents()
      } else {
        console.warn("Bundle Filter | Configuration Error: Collection Missing", this)
      }
    }
    subscribeToEvents() {
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.bundleFiltered, this.handleFilterChanged.bind(this)))
    }
    attachListeners() {
      this.addEventListener('click', this.handleClick.bind(this))
    }
    handleClick(e) {
      if (!this.active) {
        this.active = true
        this.setAttribute('data-active', true)
        publish(PUB_SUB_EVENTS.bundleFiltered, {filterValue: this.FILTER_VALUE})
      }
    }
    handleFilterChanged(e) {
      if (e.filterValue !== this.FILTER_VALUE) {
        this.active = false
        this.setAttribute('data-active', false)
      } else {
        this.active = true
        this.setAttribute('data-active', true)
      }
    }
  }
  customElements.define('td-byob-filter', BundleFilter)
}

// PRODUCTS WITHIN COLLECTION
if (!customElements.get('td-byob-facet')) {
  class BundleFacet extends TDBaseElement {
    constructor() {
      super()
      this.PAGE_SIZE = this.dataset.pageSize
      this.PAGE_PARAM = "page"
      this.BASE_URL = window.location.pathname
      this.SECTION_PARAM = 'sections'
      this.REQUESTED_SECTION_ID = 'td-byob-builder-products'
      this.COLLECTION = this.dataset.collection
      this.COLLECTION_HANDLE = this.dataset.collectionHandle
      this.PAGINATE = this.dataset.paginate && this.dataset.active != 'false'
      this.CHILDREN_SELECTOR = 'td-byob-product'
      this.OBSERVER_OPTIONS = {}
      this.ITEM_LOAD_IN_CLASS = 'td-byob__load-in'
      this.SENTINEL_INDEX = 3

      this.active = this.dataset.active && this.dataset.active != 'false'
      this.page = 2
      this.observer = null
      this.sentinel = null
      this.tags_filter = this.dataset.tagsFilter || false
      this.options_filter = this.dataset.optionsFilter || false
    }
    initializationFunction() {
      if (this.COLLECTION) {
        this.subscribeToEvents()
        if (this.PAGINATE) {
          this.configureObserver()
        }
      } else {
        console.warn("Bundle Facet | Configuration Error: Collection Missing", this)
      }
    }
    subscribeToEvents() {
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.bundleFiltered, this.handleFacetChanged.bind(this)))
    }
    handleFacetChanged(e) {
      if (e.filterValue === this.COLLECTION) {
        this.handleFacetActivation()
      } else if (this.active) {
        this.handleFacetDeactivation()
      }
    }
    handleFacetActivation() {
      this.active = true
      this.setAttribute('data-active', true)
    }
    handleFacetDeactivation() {
      this.active = false
      this.addEventListener('transitionend', () => {
        publish(PUB_SUB_EVENTS.bundleFacetChanged)
      })
      this.setAttribute('data-active', false)
    }
    configureObserver() {
      const possibleTargets = this.querySelectorAll(this.CHILDREN_SELECTOR)
      if (possibleTargets.length && possibleTargets[possibleTargets.length - 1 - this.SENTINEL_INDEX]) {
        this.sentinel  = possibleTargets[possibleTargets.length - 1 - this.SENTINEL_INDEX]
        if (this.sentinel) {
          const handler = (entries) => {
            if (entries[0].isIntersecting) {
              this.retrieveMoreOptions()
            }
          };
          this.observer = new window.IntersectionObserver(handler, this.OBSERVER_OPTIONS);
          this.observer.observe(this.sentinel);
        }
      }
    }

    retrieveMoreOptions() {
      const queryParams = new URLSearchParams();
      queryParams.set(this.PAGE_PARAM, this.page);
      queryParams.set(this.SECTION_PARAM, this.REQUESTED_SECTION_ID);
      const requestUrl = [`/collections/`, this.COLLECTION_HANDLE , "?", queryParams.toString()].join("")
      fetch(requestUrl).then(function (response) {
        return response.text();
      }).then((response) => {
        try {
          const jsonResponse = JSON.parse(response)
          const sectionContent = jsonResponse[this.REQUESTED_SECTION_ID]
          if (sectionContent) {
            const doc = new DOMParser().parseFromString(sectionContent, "text/html")
            const additionalResults = doc.querySelectorAll(this.CHILDREN_SELECTOR);
            if (additionalResults.length) {
              additionalResults.forEach((result, index) => {
                if (!this.filterValues(result.dataset.tags?.split(","), this.tags_filter)
                  || !this.filterValues(result.dataset.options?.split(","), this.options_filter)) return;
                result.classList.add(this.ITEM_LOAD_IN_CLASS)
                if (result.querySelector('img')) {
                  // NOTE Setting loading to eager to ensure that everything is loaded when it's visible
                  result.querySelector('img').setAttribute('loading','eager')
                }
                this.appendChild(result)
                result.classList.remove(this.ITEM_LOAD_IN_CLASS)
              })
              this.page += 1;
              if (this.PAGE_SIZE > additionalResults.length && this.sentinel) {
                this.observer.unobserve(this.sentinel);
              } else {
                this.configureObserver()
              }
            }
          }
        } catch (err) {
          // There was an error
          console.error("Something went wrong.", err);
        }
      })
    }

    filterValues(valuesToFilter, filters) {
      if (!filters) return true;
      let tagFound = false;
      for (let value of valuesToFilter) {
        if (filters.includes(value)) {
          tagFound = true;
          break;
        }
      }
      return tagFound;
    }
  }
  customElements.define('td-byob-facet', BundleFacet)
}

// NOTE this represents a pre-built collection that user is prompted to add, adds these to the builder
if (!customElements.get('td-byob-prompt')) {
  class BundlePrompt extends TDBaseElement {
    constructor() {
      super()
      this.PRODUCTS = this.dataset.products?.split(',') || []
      this.PROMPT_TRIGGER = this.querySelector('.td-byob__prompt-trigger')
      this.isSet = false
    }

    initializationFunction() {
      if (!this.PROMPT_TRIGGER) {
        console.warn("Bundle Prompt | Configuration Error: Trigger Missing")
        return
      }
      this.addEventListeners()
      this.subscribeToEvents()
    }

    addEventListeners() {
      this.PROMPT_TRIGGER.addEventListener('click', this.handlePromptClick.bind(this))
    }
    subscribeToEvents() {
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.bundleOpen, this.handleBundleOpen.bind(this)))
    }

    handlePromptClick() {
      if (!this.isSet) {
        this.PRODUCTS.forEach((product) => {
          const matchingProduct = document.querySelector(`td-byob-product[data-variant-id="${product}"]`)
          if (matchingProduct) {
            matchingProduct.dispatchEvent(new CustomEvent('prompt-product-added'))
          }
        })
        this.setAttribute('data-active', this.isSet)
      }
      
    }
    handleBundleOpen() {
      this.isSet = false
      this.setAttribute('data-active', this.isSet)
    }
  }

  customElements.define('td-byob-prompt', BundlePrompt)
}

// NOTE this is an item that can be added to the bundle
if (!customElements.get('td-byob-product')) {
  
  class BundleProduct extends TDBaseElement {

    constructor() {
      super()

      this.INCREMENTOR = this.querySelectorAll('[data-action="increment"]')
      this.DECREMENTOR = this.querySelector('[data-action="decrement"]')
      this.QTY_FIELD = this.querySelector('[data-quantity]')
      this.IMAGE_SRC = this.dataset.image
      this.VARIANT_ID = this.dataset.variantId
      this.PRICE = this.dataset.price
      this.PRODUCT_TITLE = this.dataset.productTitle
      this.VARIANT_TITLE = this.dataset.variantTitle
      this.hiddenProductClass = 'td-byob__disabled'

      this.active = this.dataset.active && this.dataset.active != 'false'
      this.quantity = 0
      this.temporalProductElement = null
      try {
        this.subscriptionMapping = JSON.parse(this.dataset.subscriptionMapping);
      } catch (err) {
        this.subscriptionMapping = {};
      }
      const subKeys = Object.keys(this.subscriptionMapping);
      if (subKeys.length == 1) {
        this.subscriptionPrice = parseInt(this.subscriptionMapping[subKeys[0]].price);
      } else {
        this.subscriptionPrice = this.dataset.price;
      }
    }

    initializationFunction() {
      if (this.INCREMENTOR || this.DECREMENTOR) {
        this.attachListeners()
      }
      
      this.subscribeToEvents()
    }

    subscribeToEvents() {
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.bundleItemRemoved, this.handleBundleItemRemoved.bind(this)))
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.bundleProductAdded, this.handleBundleProductAdded.bind(this)))
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.bundleOpen, this.handleBundleOpen.bind(this)))
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.bundleAdded, this.handleBundleClear.bind(this)))
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.bundleEmptied, this.handleBundleClear.bind(this)))
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.sellingPlanUpdated, this.handleSellingPlanUpdate.bind(this)))
    }
    attachListeners() {
      this.addEventListener('prompt-product-added', this.handleIncrement.bind(this))
      if (this.INCREMENTOR) {
        this.INCREMENTOR.forEach((incrementor) => {
          incrementor.addEventListener('click', this.handleIncrement.bind(this))
        })
      }
      if (this.DECREMENTOR) {
        this.DECREMENTOR.addEventListener('click', this.handleDecrement.bind(this))
      }
      
      const productCard = this.querySelector('.td-byob__product');
      if (productCard) {
        productCard.addEventListener('click', (e) => {
          if (!e.target.closest('[data-action]') && !this.classList.contains('td-byob__disabled')) {
            this.handleIncrement();
          }
        });
      }
    }
    handleIncrement() {
      if (!this.classList.contains('td-byob__disabled') && this.VARIANT_ID) {
        this.quantity += 1
        this.handleUIUpdate()
        publish(PUB_SUB_EVENTS.bundleProductAdded, this.getItemObject())
      }
    }
    handleDecrement() {
      this.quantity - 1 < 0 ? this.quantity = 0 : this.quantity -= 1
      this.handleUIUpdate()
      publish(PUB_SUB_EVENTS.bundleProductRemoved, this.getItemObject())
    }
    handleBundleClear() {
      this.quantity = 0
      this.handleUIUpdate()
    }
    handleUIUpdate() {
      if (this.quantity > 0) {
        this.active = true
      } else {
        this.active = false
      }
      this.setAttribute('data-active', this.active)

      if (this.DECREMENTOR) {
        this.DECREMENTOR.disabled = !this.active
      }
      if (this.QTY_FIELD) {
        this.QTY_FIELD.innerText = this.quantity
      }
    }
    handleBundleProductAdded(addedItem) {
      if (addedItem.variantId === this.VARIANT_ID && this !== addedItem.element ) {
        this.quantity += 1
        this.handleUIUpdate()
      }
    }
    handleBundleItemRemoved(removedItem) {
      if (removedItem.variantId == this.VARIANT_ID) {
        // If removeAll flag is set, reset quantity to 0
        if (removedItem.removeAll) {
          this.quantity = 0;
        } else {
          this.quantity - 1 < 0 ? this.quantity = 0 : this.quantity -= 1;
        }
        this.handleUIUpdate();
      } else if (this.INCREMENTOR) {
        this.INCREMENTOR.disabled = false;
      }
    }
    handleBundleOpen() {
      if (this.INCREMENTOR) {
        this.INCREMENTOR.disabled = false
      }
    }
    handleSellingPlanUpdate(sub_active) {
      if (sub_active) {
        if (Object.keys(this.subscriptionMapping).length) {
          this.classList.remove(this.hiddenProductClass);
        } else {
          this.classList.add(this.hiddenProductClass);
          this.quantity = 0;
          this.handleUIUpdate();
          publish(PUB_SUB_EVENTS.bundleProductRemoved, this.getItemObject())
        }
      } else {
        this.classList.remove(this.hiddenProductClass);
      }
    }
    getItemObject() {
      return {
        image: this.IMAGE_SRC,
        variantId: this.VARIANT_ID,
        price: this.PRICE,
        productTitle: this.PRODUCT_TITLE,
        variantTitle: this.VARIANT_TITLE,
        quantity: this.quantity,
        subscriptionMapping: this.subscriptionMapping,
        subscriptionPrice: this.subscriptionPrice,
        forTier: false,
        element: this
      }
    }
  }

  customElements.define('td-byob-product', BundleProduct)
}

// NOTE this is an item that has been added to the bundle
if (!customElements.get('td-byob-item')) {
  class BundleItem extends TDBaseElement {

    constructor() {
      super()
      this.IMAGE_ELEMENT = this.querySelector('.td-byob__item--set img')
      this.HEADING_ELEMENT = this.querySelector('.td-byob__item--set .td-byob__item-heading')
      this.DISCOUNTED_ELEMENT = this.querySelector('.td-byob__item--set .td-byob__item-discounted-price')
      this.PRICE_ELEMENT = this.querySelector('.td-byob__item--set .td-byob__item-price')
      this.REMOVER = this.querySelector('.td-byob__item--set .td-byob__item-remove')
      this.PLACEHOLDER = this.querySelector('.td-byob__item-placeholder')
      this.INCREMENTOR = this.querySelector('[data-action="increment"]')
      this.DECREMENTOR = this.querySelector('[data-action="decrement"]')
      this.QTY_FIELD = this.querySelector('[data-quantity]')
      this.IS_EXTRA = this.dataset.extra == "true";

      this.isSet = false
      this.variantId = null
      this.productTitle = null
      this.variantTitle = null
      this.price = null
      this.image = null
      this.subscriptionPrice = null
      this.discountAmount = 0
      this.isFree = false
      this.forTier = false
      this.quantity = 0
    }

    initializationFunction() {
      this.attachListeners()
      this.subscribeToEvents()
    }
    attachListeners() {
      if (this.REMOVER) {
        this.REMOVER.addEventListener('click', this.removeBundleItem.bind(this))
      }
      if (this.PLACEHOLDER) {
        this.PLACEHOLDER.addEventListener('click', this.handlePlaceholderClick.bind(this))
      }
      if (this.INCREMENTOR) {
        this.INCREMENTOR.addEventListener('click', this.handleIncrement.bind(this))
      }
      if (this.DECREMENTOR) {
        this.DECREMENTOR.addEventListener('click', this.handleDecrement.bind(this))
      }
    }
    subscribeToEvents() {
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.bundleDiscountSet, this.handleBundleDiscountSet.bind(this)))
    }
    
    handleIncrement() {
      this.quantity += 1;
      this.updateUI();
      publish(PUB_SUB_EVENTS.bundleProductAdded, this.getItemObject());
    }

    handleDecrement() {
      if (this.quantity > 1) {
        this.quantity -= 1;
        this.updateUI();
        publish(PUB_SUB_EVENTS.bundleProductRemoved, this.getItemObject());
      } else {
        this.removeBundleItem();
      }
    }
    
    getItemObject() {
      return {
        image: this.image,
        variantId: this.variantId,
        price: this.price,
        productTitle: this.productTitle,
        variantTitle: this.variantTitle,
        quantity: this.quantity,
        subscriptionPrice: this.subscriptionPrice,
        isFree: this.isFree,
        forTier: this.forTier,
        element: this
      }
    }
    
    setItem({variantId, productTitle, variantTitle, price, image, subscriptionPrice, isFree, forTier, quantity = 1}, discount = false) {
      this.variantId = variantId
      this.productTitle = productTitle
      this.variantTitle = variantTitle
      this.price = price
      this.image = image
      this.isSet = true
      this.quantity = quantity
      this.subscriptionPrice = subscriptionPrice
      this.isFree = isFree || false
      this.forTier = forTier || false
      discount ? this.discountAmount = discount : null
      this.updateUI()
    }

    updateUI() {
      if (this.isSet) {
        if (this.IMAGE_ELEMENT) {
          this.IMAGE_ELEMENT.src = this.image
          this.IMAGE_ELEMENT.alt = [this.productTitle, this.variantTitle].join(' ')
        }
        if (this.HEADING_ELEMENT) {
          this.HEADING_ELEMENT.innerHTML = this.productTitle
          
          // Add "FREE" indicator if the item is free
          if (this.isFree) {
            this.HEADING_ELEMENT.innerHTML += ' <span class="td-byob__item-free-badge">FREE</span>';
          }
        }
        
        if (this.DISCOUNTED_ELEMENT) {
          if (this.isFree) {
            // If item is free, show $0
            this.DISCOUNTED_ELEMENT.innerHTML = this.formatMoney(0);
          } else {
            const discountedPrice = this.price * (1 - this.discountAmount)
            this.DISCOUNTED_ELEMENT.innerHTML = discountedPrice != this.price ? this.formatMoney(discountedPrice / 100) : null
          }
        }
        
        if (this.PRICE_ELEMENT) {
          if (this.isFree) {
            // If item is free, show original price with strikethrough
            this.PRICE_ELEMENT.innerHTML = `<s>${this.formatMoney(this.price / 100)}</s>`;
          } else {
            this.PRICE_ELEMENT.innerHTML = this.formatMoney(this.price / 100)
          }
        }
        
        // Update quantity display
        if (this.QTY_FIELD) {
          this.QTY_FIELD.innerText = this.quantity;
        }
        
        // Enable/disable buttons based on state
        if (this.INCREMENTOR) {
          this.INCREMENTOR.disabled = !this.variantId;
        }
        
        if (this.DECREMENTOR) {
          this.DECREMENTOR.disabled = this.quantity <= 1 || !this.variantId;
        }
        
        // Set data-free attribute for styling
        if (this.isFree) {
          this.setAttribute('data-free', 'true');
        } else {
          this.removeAttribute('data-free');
        }
      } else {
        if (this.IMAGE_ELEMENT) {
          this.IMAGE_ELEMENT.src = null
        }
        
        // Disable buttons when no variant is selected
        if (this.INCREMENTOR) {
          this.INCREMENTOR.disabled = true;
        }
        
        if (this.DECREMENTOR) {
          this.DECREMENTOR.disabled = true;
        }
        
        // Reset quantity display to 0
        if (this.QTY_FIELD) {
          this.QTY_FIELD.innerText = "0";
        }
        
        this.removeAttribute('data-free');
      }
      this.setAttribute('data-active', this.isSet)
    }

    removeBundleItem() {
      // NOTE this is a hotfix to prevent event from tripping twice?
      if (this.variantId) {
        const oldId = this.variantId
        const oldTier = this.forTier
        // Store the quantity before resetting
        const quantity = this.quantity
        this.resetData()
        this.updateUI()
        // Publish event to remove the entire item
        publish(PUB_SUB_EVENTS.bundleItemRemoved, {
          variantId: oldId, 
          forTier: oldTier,
          quantity: quantity, // Pass the quantity to ensure all instances are removed
          removeAll: true // Flag to indicate removing all instances of this item
        })
      }
    }

    handleBundleProductRemoved(removedProduct) {
      if (removedProduct.variantId == this.variantId) {
        this.removeBundleItem()
      }
    }

    handleBundleDiscountSet(newAmount) {
      this.discountAmount = newAmount
      this.updateUI()
    }

    resetData() {
      this.isSet = false
      this.variantId = null
      this.productTitle = null
      this.variantTitle = null
      this.price = null
      this.image = null
      this.subscriptionPrice = null
      this.quantity = 0
      this.isFree = false
      this.forTier = false
    }
    handleBundleAdded() {
      this.resetData()
      this.updateUI()
    }

    handlePlaceholderClick() {
      const collectionContainer = document.querySelector('.td-byob__collections');
      if (collectionContainer) {
        collectionContainer.scrollIntoView({ behavior: 'smooth' });
      }
    }
    // NOTE this coupling isn't ideal but it is cleaner then any other solution
    clearItem() {
      if(this.IS_EXTRA) {
        this.remove()
        return
      }
      this.resetData()
      this.updateUI()
    }
    
  }

  customElements.define('td-byob-item', BundleItem)
}

if (!customElements.get('td-byob-controller')) {
  class BundleController extends TDBaseElement {

    constructor() {
      super()
      this.ACTION_ELEMENT = this.querySelector('.td-byob__action')
      this.PROGRESS_BAR = this.querySelector('td-byob-progress-bar')

      this.ACTION_PRICE_SELECTOR = ".td-byob__action-price"
      this.ACTION_TEXT_SELECTOR = '.td-byob__action__next'
      this.ACTION_COMPARE_AT_PRICE_SELECTOR = '.td-byob__compare-at-price'
      this.INNER_CONTENT_SELECTOR = '.td-byob__content__wrapper'
      this.COUNT_SELECTOR = '.td-byob__count'

      this.CART_ENDPOINT = '/cart/add.js'
      this.BUNDLE_ITEM_LINE_ITEM_PROP = '__byob-item'
      this.BUNDLE_ITEM_LINE_FULL_PRICE_ITEM_PROP = 'regular'
      this.GIFT_LINE_ITEM_PROP = 'free'
      this.SHOW_DETAILS_CLASS = 'td-byob-controller--show-details'
      
      this.bundleItemsWrapper = this.querySelector('[data-items-wrapper]');
      this.bundleItemElements = [...this.querySelectorAll('td-byob-item')]
      this.bundleItemsBaseSize = this.bundleItemElements.length;
      this.bundleItems = []
      this.totalItems = 0
      this.totalAmount = 0
      this.compareAtPrice = 0

      this.bundleTiers = [...this.querySelectorAll('td-byob-tier')]

      this.discountAmount = 0
      this.skipCart = this.dataset.skipCart === 'true' || false;
      this.completedMsg = this.dataset.completedMsg || false
      this.messageContainer = this.querySelector('.td-byob__action__next')

      this.subscriptionActive = this.dataset.subscriptionActive == 'true' || false
      
      this.observerClass = "td-byob-controller--fixed";
      this.observerSentinelSelector = ".td-byob__sentinel";
      
      // Temporal products management
      this.temporalProducts = new Map(); // Map to track temporal products by variantId

      // TODO move the last discount here, then we push the call out to the items
    }

    initializationFunction() {
      if (!this.bundleItemsWrapper) {
        console.warn("Bundle Contoller | Configuration Error: Item Container Not Present")
        return
      }
      if (!this.ACTION_ELEMENT) {
        console.warn("Bundle Contoller | Configuration Error: Action Not Present")
        return
      }
      if (!this.bundleTiers.length) {
        console.warn("Bundle Contoller | Configuration Error: Bundle Tiers Not Present")
        return
      }
      this.addEventListeners()
      this.subscribeToEvents()
      
      // Set up the intersection observer for sticky functionality
      setTimeout(() => {
        this.setupScrollObserver()
      }, 100);
    }

    addEventListeners() {
      this.ACTION_ELEMENT.addEventListener('click', this.handleActionClicked.bind(this))
      const bundleToggle = this.querySelector('[data-toggle-details]');
      if (bundleToggle) {
        bundleToggle.addEventListener('click', () => {
          this.classList.toggle(this.SHOW_DETAILS_CLASS);
        })
      }
    }

    subscribeToEvents() {
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.bundleProductAdded, this.handleBundleProductAdded.bind(this)))
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.bundleProductRemoved, this.handleBundleProductRemoved.bind(this)))
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.bundleItemRemoved, this.handleBundleProductRemoved.bind(this)))
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.bundleGiftGranted, this.handleBundleGiftAdded.bind(this)))
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.bundleGiftRevoked, this.handleBundleGiftRemoved.bind(this)))
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.sellingPlanUpdated, this.handleSellingPlanUpdate.bind(this)))
    }

    handleSellingPlanUpdate(sub_active) {
      this.subscriptionActive = sub_active;
      this.updateUI();
    }
      
    updateAllTiers() {
      const bundleData = {totalAmount: this.totalAmount, totalItems: this.totalItems, subActive: this.subscriptionActive};
      
      // Update all tiers with the current data one by one
      for (const tier of this.bundleTiers) {
        tier.updateTier(bundleData);
      }
      
      this.updateProgressBar();
      this.updateMessaging();
    }

    handleBundleProductAdded(addedProduct) {
      if (addedProduct.isFree) {
        const alreadyAdded = this.bundleItems.filter((item) => item && item.variantId == addedProduct.variantId && item.forTier == addedProduct.forTier)
        if(alreadyAdded.length) {
          return
        }
      }
      this.bundleItems.push(addedProduct);
      this.createOrUpdateTemporalProduct(addedProduct);
      this.updateUI()
    }

    handleBundleProductRemoved(removedProduct) {
      const {variantId, forTier, removeAll} = removedProduct
      
      if (removeAll) {
        // Remove all instances of this item
        this.bundleItems = this.bundleItems.filter(item => 
          !(item && item.variantId == variantId && item.forTier == forTier)
        );
      } else {
        // Remove just one instance
        const lastMatching = [...this.bundleItems].reverse().findIndex((item) => item && item.variantId == variantId && item.forTier == forTier)
        if (lastMatching > -1) {
          this.bundleItems[ this.bundleItems.length - lastMatching - 1 ] = undefined
        }
        this.bundleItems = this.bundleItems.filter( Boolean );
      }
      
      this.updateTemporalProducts();
      
      if (this.bundleIsEmpty()) publish(PUB_SUB_EVENTS.bundleEmptied);
      this.updateUI();
    }

    bundleIsEmpty() {
      return this.bundleItems.length == 0
    }

    fetchCart() {
      return fetch('/cart.js', {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      }).then((response) => response.json());
    }

    removeBundleItems(cart) {
      const bundleItemsToRemove = cart.items.filter(item => item.properties && item.properties[this.BUNDLE_ITEM_LINE_ITEM_PROP]);
      if (bundleItemsToRemove.length === 0) {
        return Promise.resolve(); // No items to remove, return resolved promise
      }

      const updates = bundleItemsToRemove.reduce((acc, bundleItem) => {
        acc[bundleItem.key] = 0; // Use line item key instead of id
        return acc;
      }, {});

      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ updates: updates })
      });
    }

    addItemsToCart(items) {
      return fetch(this.CART_ENDPOINT, {
        body: JSON.stringify({ items }),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        method: 'POST'
      }).then((response) => response.json());
    }

    prepareCartItems() {
      const items = [];
      const itemMapping = {};

      // Process regular items
      this.bundleItems.forEach((item) => {
        if (item && !item.isFree) {
          if (!itemMapping[item.variantId]) {
            itemMapping[item.variantId] = 1;
            if (this.subscriptionActive) {
              const subKeys = Object.keys(item.subscriptionMapping);
              if (subKeys.length == 1) {
                itemMapping[`${item.variantId}_plan`] = parseInt(
                  item.subscriptionMapping[subKeys[0]].id
                );
              }
            }
          } else {
            itemMapping[item.variantId] += 1;
          }
        }
      });

      // Add regular items to cart
      Object.keys(itemMapping).forEach((variantId) => {
        if (variantId.includes('plan')) return;
        const itemObject = {
          id: variantId,
          quantity: itemMapping[variantId],
          properties: {}
        };
        itemObject.properties[this.BUNDLE_ITEM_LINE_ITEM_PROP] = this.BUNDLE_ITEM_LINE_FULL_PRICE_ITEM_PROP;
        if (this.subscriptionActive && itemMapping[`${variantId}_plan`]) {
          itemObject.selling_plan = itemMapping[`${variantId}_plan`];
        }
        items.push(itemObject);
      });

      // Add free items to cart
      this.bundleItems.forEach((item) => {
        if (item && item.isFree) {
          const itemObject = {
            id: item.variantId,
            quantity: 1,
            properties: {}
          };
          itemObject.properties[this.BUNDLE_ITEM_LINE_ITEM_PROP] = this.GIFT_LINE_ITEM_PROP;
          items.push(itemObject);
        }
      });

      return items;
    }

    handleActionClicked(e) {
      e.preventDefault();
      this.ACTION_ELEMENT.classList.add('loading');
      this.ACTION_ELEMENT.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

      const items = this.prepareCartItems();

      this.fetchCart()
        .then((cart) => this.removeBundleItems(cart))
        .then(() => this.addItemsToCart(items))
        .then(() => {
          publish(PUB_SUB_EVENTS.bundleAdded);
          this.bundleItems = [];
          this.clearTemporalProducts();
          this.updateUI();
          if (this.skipCart) {
            window.location.href = '/checkout';
          } else {
            // if (GND) {
            //   GND.sidecart.refresh();
            // }
            // if (RC) {
            //   RC.sidePanel.open("#cart_panel");
            // }
            this.fetchCart().then((response) => {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'byob',
                  cartData: response,
                })
              })
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.ACTION_ELEMENT.classList.remove('loading');
          this.ACTION_ELEMENT.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
        });
    }

    updateUI() {
      this.updateTotalItems()
      this.updateTotalAmount()
      this.updateBundleItemUI()
      this.updateAllTiers()
    }

    updateTotalItems() {
      this.totalItems = this.bundleItems.reduce((total, item) => {
        if (item) {
          // Don't count free items in the total
          if (!item.isFree) {
            return total + 1;
          }
        }
        return total;
      }, 0);
      
      // Update any UI elements that display the total items count
      const totalItemsElement = this.querySelector('[data-total-items]');
      if (totalItemsElement) {
        totalItemsElement.textContent = this.totalItems;
      }
    }

    updateTotalAmount() {
      this.totalAmount = this.bundleItems.reduce((total, item) => {
        if (item) {
          // Free items don't contribute to the total amount
          if (item.isFree) {
            return total;
          }
          
          if (this.subscriptionActive) {
            // If the item is a subscription, use the subscription price
            if (item.subscriptionPrice) {
              return total + (parseInt(item.subscriptionPrice) * (1 - this.discountAmount));
            }
          } else if (item.price) {
            // Apply discount to each item's price
            const itemPrice = parseInt(item.price) * (1 - this.discountAmount);
            return total + itemPrice;
          }
        }
        return total;
      }, 0);
      
      this.compareAtPrice = this.bundleItems.reduce((total, item) => {
        if (item) {
          return total + parseInt(item.price)
        }
        return total
      }, 0)

      this.updateTotalsUI()
    }

    updateBundleItemUI() {
      // Clear all items first to ensure a clean state
      this.bundleItemElements.forEach((element) => {
        element.clearItem();
      });
      
      // Group items by variantId, except for free items
      const groupedItems = {};
      const freeItems = [];
      
      this.bundleItems.forEach((item) => {
        if (item) {
          if (item.isFree) {
            freeItems.push(item);
          } else {
            const key = item.variantId;
            if (!groupedItems[key]) {
              groupedItems[key] = {...item, quantity: 1};
            } else {
              groupedItems[key].quantity += 1;
            }
          }
        }
      });
      
      // Display grouped items
      let index = 0;
      
      // First display regular grouped items
      Object.values(groupedItems).forEach((item) => {
        if (index < this.bundleItemElements.length) {
          this.bundleItemElements[index].setItem(item, this.discountAmount);
        } else {
          const newItem = this.createNewEmptyItem();
          newItem.setItem(item, this.discountAmount);
        }
        index++;
      });
      
      // Then display free items
      freeItems.forEach((item) => {
        if (index < this.bundleItemElements.length) {
          this.bundleItemElements[index].setItem(item, this.discountAmount);
        } else {
          const newItem = this.createNewEmptyItem();
          newItem.setItem(item, this.discountAmount);
        }
        index++;
      });
      
      // Update the bundleItemElements array after potential DOM changes
      this.bundleItemElements = [...this.querySelectorAll('td-byob-item')];
      
      // Update the swiper if it exists
      if (this.bundleItemsWrapper) {
        this.bundleItemsWrapper.dispatchEvent(new CustomEvent('refresh', {bubbles: true}));
      }
    }

    updateProgressBar() {
      publish(PUB_SUB_EVENTS.updateProgressBar, {totalAmount: this.totalAmount, totalItems: this.totalItems})
    }

    updateTotalsUI() {
      const priceContainer = this.querySelector(this.ACTION_PRICE_SELECTOR)
      const compareAtPriceContainer = this.querySelector(this.ACTION_COMPARE_AT_PRICE_SELECTOR)
      const countContainer = this.querySelector(this.COUNT_SELECTOR)
      if (priceContainer) {
        priceContainer.innerHTML = this.formatMoney(this.totalAmount / 100)
      } 
      if (compareAtPriceContainer) {
        if (this.compareAtPrice > this.totalAmount) {
          compareAtPriceContainer.innerHTML = this.formatMoney(this.compareAtPrice/ 100)
        } else {
          compareAtPriceContainer.innerHTML = ""
        }
      }
      if (countContainer) {
        countContainer.innerHTML = this.totalItems
      }
    }

    updateMessaging() {
      const lastActive = [...this.bundleTiers].reverse().find((tier) => tier.getIsActive())

      if(!lastActive) {
        this.ACTION_ELEMENT.disabled = true
      } else {
        this.ACTION_ELEMENT.disabled = false
      }

      if(!this.messageContainer) return;
      const lastActiveTierIndex = this.bundleTiers.indexOf(lastActive);
      const isLastTier = lastActiveTierIndex === this.bundleTiers.length - 1;
      
      if (isLastTier) {
        const requiredAmount = lastActive.getTierRequiredAmount() - this.totalAmount || 0;
        const requiredQuantity = lastActive.dataset.qty - this.totalItems || 0;
        this.messageContainer.innerText = this.completedMsg.replace('[amount]', this.formatMoney(requiredAmount / 100)).replace('[qty]', requiredQuantity)
        return;
      }
      
      const nextTier = this.bundleTiers[lastActiveTierIndex + 1];
      if (nextTier) {
        if(nextTier.dataset?.active == "true" && nextTier.dataset?.type == "free_product") {
          this.messageContainer.innerText = nextTier.getGiftMessage()
          return
        }
        const requiredAmount = nextTier.getTierRequiredAmount() - this.totalAmount || 0;
        const requiredQuantity = nextTier.dataset.qty - this.totalItems || 0;
        this.messageContainer.innerText = nextTier.getTierMessage().replace('[amount]', this.formatMoney(requiredAmount / 100)).replace('[qty]', requiredQuantity)
      } 
    }

    handleBundleGiftAdded(tierId) {
      if (!tierId) return;
      const giftIsPresent = this.bundleItems.find((item) => item && item.forTier == tierId)
      if (giftIsPresent) return;

      for (let i = this.bundleItems.length - 1; i >= 0; i--) {
        if (this.bundleItems[i]?.forTier === false) {
          Object.assign(this.bundleItems[i], { isFree: true, forTier: tierId });
          break;
        }
      }
      this.updateUI()
    }

    handleBundleGiftRemoved(data) {
      const {variantId, forTier} = data
      if (!forTier) return;
      if(variantId) {
        const itemIndex = this.bundleItems.findIndex((item) => item && item.variantId == variantId && item.forTier == forTier);
        if (itemIndex > -1) {
          const item = this.bundleItems[itemIndex];
          const elementToRemove = this.bundleItemElements.find(element => 
            element.variantId === item.variantId && element.forTier === item.forTier
          );
          if (elementToRemove) {
            elementToRemove.removeBundleItem();
          }
        }
      } else {
        const itemToRemove = this.bundleItems.find((item) => item && item.forTier == forTier)
        if (itemToRemove) {
          itemToRemove.isFree = false
          itemToRemove.forTier = false
          this.updateUI();
        }
      }
    }

    createNewEmptyItem() {
      const newItem = this.querySelector(
        "[data-bundle-template='item']"
      ).content.firstElementChild.cloneNode(true);
      this.bundleItemsWrapper.appendChild(newItem);
      return this.querySelector('td-byob-item:last-child');
    }
    
    createOrUpdateTemporalProduct(product) {
      if (!product || product.isFree) return;
      
      const variantId = product.variantId;
      const byobDetails = this.querySelector('.td-byob__details');
      if (!byobDetails) return;
      
      if (this.temporalProducts.has(variantId)) {
        this.updateTemporalProductQuantity(variantId);
        return;
      }
      
      const template = this.querySelector('[data-bundle-template="temporal-product"]');
      if (!template) return;
      
      const temporalElement = template.content.firstElementChild.cloneNode(true);
      
      const img = temporalElement.querySelector('img');
      if (img) {
        img.src = product.image;
        img.alt = product.productTitle;
      }
      
      const content = temporalElement.querySelector('.td-byob__product-temporal__content');
      if (content) {
        content.innerHTML = `<h3>${product.productTitle}</h3>`;
      }
      
      this.setupTemporalProductListeners(temporalElement, variantId);
      
      this.temporalProducts.set(variantId, temporalElement);
      byobDetails.appendChild(temporalElement);
      
      this.updateTemporalProductQuantity(variantId);
    }
    
    updateTemporalProducts() {
      const variantQuantities = {};
      this.bundleItems.forEach(item => {
        if (item && !item.isFree) {
          variantQuantities[item.variantId] = (variantQuantities[item.variantId] || 0) + 1;
        }
      });
      
      this.temporalProducts.forEach((element, variantId) => {
        const quantity = variantQuantities[variantId] || 0;
        if (quantity === 0) {
          element.remove();
          this.temporalProducts.delete(variantId);
        } else {
          this.updateTemporalProductQuantity(variantId, quantity);
        }
      });
    }
    
    updateTemporalProductQuantity(variantId, quantity = null) {
      const temporalElement = this.temporalProducts.get(variantId);
      if (!temporalElement) return;
      
      if (quantity === null) {
        quantity = this.bundleItems.filter(item => 
          item && !item.isFree && item.variantId === variantId
        ).length;
      }
      
      const qtyField = temporalElement.querySelector('[data-quantity]');
      if (qtyField) {
        qtyField.innerText = quantity;
      }
      
      const decrementor = temporalElement.querySelector('[data-action="decrement"]');
      if (decrementor) {
        decrementor.disabled = quantity <= 0;
      }
    }
    
    setupTemporalProductListeners(temporalElement, variantId) {
      const incrementor = temporalElement.querySelector('[data-action="increment"]');
      const decrementor = temporalElement.querySelector('[data-action="decrement"]');
      
      if (incrementor) {
        incrementor.addEventListener('click', () => {
          const productElement = document.querySelector(`td-byob-product[data-variant-id="${variantId}"]`);
          if (productElement) {
            productElement.handleIncrement();
          }
        });
      }
      
      if (decrementor) {
        decrementor.addEventListener('click', () => {
          const productElement = document.querySelector(`td-byob-product[data-variant-id="${variantId}"]`);
          if (productElement) {
            productElement.handleDecrement();
          }
        });
      }
    }
    
    clearTemporalProducts() {
      this.temporalProducts.forEach((element) => {
        element.remove();
      });
      this.temporalProducts.clear();
    }
    
    setupScrollObserver() {
      const sentinel = this.querySelector(this.observerSentinelSelector);
      const innerContent = this.querySelector(this.INNER_CONTENT_SELECTOR);
      const observerClass = this.observerClass;

      if (sentinel && innerContent) {
        const syncStickyState = () => {
          const shouldFix = sentinel.getBoundingClientRect().bottom < 0;

          if (shouldFix) {
            innerContent.classList.add(observerClass);
          } else if (innerContent.classList.contains(observerClass)) {
            innerContent.classList.remove(observerClass);
            this.classList.remove(this.SHOW_DETAILS_CLASS);
          }
        };

        const handler = () => {
          syncStickyState();
        };
    
        const options = {
          rootMargin: `0px 0px 0px 0px`, // Observe the sentinel directly
          threshold: 0,
        };
        this.observer = new IntersectionObserver(handler, options);
        this.observer.observe(sentinel);
        syncStickyState();
      }
    }
  }

  customElements.define('td-byob-controller', BundleController)
}

if (!customElements.get('td-byob-tier')) {
  class BundleTier extends TDBaseElement {
    constructor() {
      super()
      this.TYPE = this.dataset.type
      this.TIER_AMOUNT = this.dataset.amount || 0
      this.TIER_QTY = this.dataset.qty || 0
      this.TIER_MESSAGE = this.dataset.message
      this.GIFT_MESSAGE = this.dataset.giftMessage
      this.FOR_TIER = this.dataset.for
      this.VARIANT_ID = this.dataset.variantId || false
      this.currentAmount = 0
      this.active = false
      this.totalAmount = 0
      this.totalItems = 0
      this.subActive = false
    }

    initializationFunction() {
      this.subscribeToEvents()
    }

    subscribeToEvents() {
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.bundleTierUpdate, this.updateTier.bind(this)))
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.sellingPlanUpdated, this.updateTierPricing.bind(this)))
    }
    
    updateTierPricing(subscriptionActive) {
      this.TIER_AMOUNT = subscriptionActive && this.dataset.subscriptionAmount ? 
        parseInt(this.dataset.subscriptionAmount) : 
        parseInt(this.dataset.amount);
      
      const tierLabel = this.querySelector('.td-byob__progress-bar__tier-label');
      if (tierLabel && this.TYPE != 'minimum-quantity') {
        const price = subscriptionActive && this.dataset.subscriptionAmount ? 
          (parseInt(this.dataset.subscriptionAmount) / 100).toFixed() : 
          (parseInt(this.dataset.amount) / 100).toFixed();
        tierLabel.textContent = `$${price}`;
      }
    }
    
    updateTier(bundleData) {
      const {totalAmount, totalItems, subActive} = bundleData || {totalAmount: this.totalAmount, totalItems: this.totalItems, subActive: this.subActive};
      this.totalAmount = totalAmount;
      this.totalItems = totalItems;
      this.subActive = subActive;
      const tierAmount = subActive && this.dataset.subscriptionAmount ? 
        parseInt(this.dataset.subscriptionAmount) : 
        parseInt(this.dataset.amount);
      this.TIER_AMOUNT = tierAmount || 0;
      const controller = document.querySelector('td-byob-controller');
      
      if (this.TYPE === 'free_preselected_product' && this.VARIANT_ID) {
        const wasActive = this.active;
        this.active = false;
        if(this.TIER_QTY <= totalItems && tierAmount <= totalAmount) {
          this.active = true;
        }
        this.setAttribute('data-active', this.active);
        
        if (this.active && !wasActive) {
          const freeProductData = {
            variantId: this.VARIANT_ID,
            productTitle: this.dataset.title || 'Free Product',
            variantTitle: '',
            price: 0,
            image: this.dataset.image || '',
            quantity: 1,
            isFree: true,
            forTier: this.FOR_TIER
          };
          publish(PUB_SUB_EVENTS.bundleProductAdded, freeProductData);
        } else if (!this.active && wasActive) {
          publish(PUB_SUB_EVENTS.bundleGiftRevoked, { variantId: this.VARIANT_ID, forTier: this.FOR_TIER});
        } else if (this.active && wasActive) {
          const freeItemExists = controller && controller.bundleItems.some(item => 
            item && item.variantId === this.VARIANT_ID && item.isFree && item.forTier === this.FOR_TIER);
          
          if (!freeItemExists) {
            // Free item is missing, add it back
            const freeProductData = {
              variantId: this.VARIANT_ID,
              productTitle: this.dataset.title || 'Free Product',
              variantTitle: '',
              price: 0,
              image: this.dataset.image || '',
              quantity: 1,
              isFree: true,
              forTier: this.FOR_TIER
            };
            
            publish(PUB_SUB_EVENTS.bundleProductAdded, freeProductData);
          }
        }
      } else if (this.TYPE === 'free_product') {
        const oldAmount = this.currentAmount;
        const wasActive = this.active;
        this.currentAmount = totalAmount;

        if(this.TIER_QTY <= totalItems && tierAmount <= oldAmount && tierAmount <= totalAmount) {
          this.active = true;
        } else {
          this.active = false;
        }

        if(this.TIER_QTY <= totalItems && tierAmount <= totalAmount) {
          this.setAttribute('data-active', true);
        } else {
          this.setAttribute('data-active', false);
        }
        if (this.active) {
          // Check if any item is marked as free for this tier
          const freeItemExists = controller && controller.bundleItems.some(item => 
            item && item.isFree && item.forTier === this.FOR_TIER);
          if (!freeItemExists && controller && controller.bundleItems.length > 0) {
            // No free item for this tier, mark the last non-free item as free
            publish(PUB_SUB_EVENTS.bundleGiftGranted, this.FOR_TIER);
          }
        } else if (!this.active && wasActive) {
          publish(PUB_SUB_EVENTS.bundleGiftRevoked, { variantId: false, forTier: this.FOR_TIER});
        } 
      } else {
        this.active = false;
        if (this.TIER_QTY <= totalItems && tierAmount <= totalAmount) {
          this.active = true;
        }
        this.setAttribute('data-active', this.active);
      }
    }

    getDiscountAmount() {
      return this.DISCOUNT_AMOUNT
    }
    getForBlock() {
      return this.FOR_TIER
    }
    getIsActive() {
      return this.active
    }
    getTierMessage() {
      return this.TIER_MESSAGE
    }
    getGiftMessage() {
      return this.GIFT_MESSAGE
    }
    getTierRequiredAmount(sub_active = false) {
      if (sub_active && this.dataset.subscriptionAmount) {
        return parseInt(this.dataset.subscriptionAmount) || 0
      }
      return parseInt(this.TIER_AMOUNT) || 0
    }
    getTierRequiredQuantity() {
      return this.TIER_QTY
    }

  }

  customElements.define('td-byob-tier', BundleTier)
}

if (!customElements.get('td-byob-progress-bar')) {  
  class BundleProgressBar extends TDBaseElement {
    constructor() {
      super()
      this.CSS_VAR_X = '--td-byob__progress-bar-percentage-x'
      this.bundleTiers = [...this.querySelectorAll('td-byob-tier')]
      this.totalAmount = 0
      this.totalItems = 0
    }

    initializationFunction() {
      if (!this.bundleTiers.length) {
        console.warn("Bundle Progress Bar | Configuration Error: Bundle Tiers")
        return
      }
      this.subscribeToEvents()
      
      let resizeTimeoutId;
      const resizeObserver = new ResizeObserver(entries => {
        clearTimeout(resizeTimeoutId);
        resizeTimeoutId = setTimeout(() => {
          this.updateProgressBar()
        }, 200);
      });
    
      resizeObserver.observe(this);
    }

    subscribeToEvents() {
      this.unsubscibeFunctions.push(subscribe(PUB_SUB_EVENTS.updateProgressBar, this.updateProgressBar.bind(this)))
    }

    updateProgressBar(bundleData) {
      const {totalAmount, totalItems} = bundleData || {totalAmount: this.totalAmount, totalItems: this.totalItems};
      this.totalAmount = totalAmount;
      this.totalItems = totalItems;
      const lastActiveTier = [...this.bundleTiers].reverse().find((tier) => tier.getIsActive());
      const firstTier = this.bundleTiers[0];
      const parentDimensions = this.getBoundingClientRect();
      const isSubscription = document.querySelector('input[name="td-byob__subscription"]')?.checked || false;
      
      if (!lastActiveTier) {
        if (firstTier && (totalItems > 0 || totalAmount > 0)) {
          let nextTierAmount = parseFloat(firstTier.getTierRequiredAmount(isSubscription)) || 0;
          let nextTierQuantity = parseInt(firstTier.getTierRequiredQuantity()) || 0;
          let progressMetric, nextTierValue;
          
          if (nextTierAmount > 0) {
            progressMetric = 'amount';
            nextTierValue = nextTierAmount;
          } else {
            progressMetric = 'quantity';
            nextTierValue = nextTierQuantity;
          }
          
          let currentValue = progressMetric === 'amount' ? totalAmount : totalItems;
          let progressPercentage = Math.min(currentValue / nextTierValue, 1);
          
          const firstTierRect = firstTier.getBoundingClientRect();
          const firstTierX = (((firstTierRect.left + (firstTierRect.width / 2) - parentDimensions.left) - firstTierRect.width/4)/ this.clientWidth) * 100;
          const newX = firstTierX * progressPercentage;
          
          this.style.setProperty(this.CSS_VAR_X, `${newX}%`);
        } else {
          this.style.setProperty(this.CSS_VAR_X, '0%');
        }
        return;
      }
      
      const lastActiveTierIndex = this.bundleTiers.indexOf(lastActiveTier);
      const isLastTier = lastActiveTierIndex === this.bundleTiers.length - 1;
      
      if (isLastTier) {
        this.style.setProperty(this.CSS_VAR_X, '100%');
        return;
      }
      
      const nextTier = this.bundleTiers[lastActiveTierIndex + 1];
      
      let currentTierAmount = parseFloat(lastActiveTier.getTierRequiredAmount(isSubscription)) || 0;
      let nextTierAmount = parseFloat(nextTier.getTierRequiredAmount(isSubscription)) || 0;
      let currentTierQuantity = parseInt(lastActiveTier.getTierRequiredQuantity()) || 0;
      let nextTierQuantity = parseInt(nextTier.getTierRequiredQuantity()) || 0;
      let progressMetric, currentTierValue, nextTierValue;
      
      if (nextTierAmount > 0) {
        progressMetric = 'amount';
        currentTierValue = currentTierAmount;
        nextTierValue = nextTierAmount;
      } else {
        progressMetric = 'quantity';
        currentTierValue = currentTierQuantity;
        nextTierValue = nextTierQuantity;
      }
      
      let progressPercentage = 0;
      let currentValue = progressMetric === 'amount' ? totalAmount : totalItems;
      
      if (nextTierValue > currentTierValue) {
        progressPercentage = Math.min(
          (currentValue - currentTierValue) / (nextTierValue - currentTierValue),
          1
        );
      }
      
      const currentTierRect = lastActiveTier.getBoundingClientRect();
      const nextTierRect = nextTier.getBoundingClientRect();
      const currentTierX = ((currentTierRect.left + (currentTierRect.width / 2) - parentDimensions.left) / this.clientWidth) * 100;
      const nextTierX = ((nextTierRect.left + (nextTierRect.width / 2) - parentDimensions.left) / this.clientWidth) * 100;
      const newX = currentTierX + ((nextTierX - currentTierX) * progressPercentage);
      
      this.style.setProperty(this.CSS_VAR_X, `${newX}%`);
    }
  }

  customElements.define('td-byob-progress-bar', BundleProgressBar)
}


if (!customElements.get('td-byob-selling-plan')) {  
  class BundleSellingPlan extends TDBaseElement {
    constructor() {
      super()
      this.subscriptionSelector = "input[type='checkbox']";
      this.isSubscription = true;
      this.isUpdating = false;
    }

    initializationFunction() {
      const subscriptionTrigger = this.querySelector(this.subscriptionSelector);
      if (subscriptionTrigger) {
        subscriptionTrigger.addEventListener(
          "change",
          this.handleSubscriptionChange.bind(this)
        );
        this.handleSubscriptionChange();
        this.unsubscibeFunctions.push(
          subscribe(PUB_SUB_EVENTS.sellingPlanUpdated, this.handleSellingPlanUpdated.bind(this))
        );
      }
    }

    handleSubscriptionChange(e) {
      if (this.isUpdating) return;
      
      const target = e
        ? e.target
        : this.querySelector(this.subscriptionSelector);
      if (target && target.checked) {
        this.isSubscription = true;
      } else {
        this.isSubscription = false;
      }
      if (this.dataset && this.dataset.plan) {
        this.dataset.plan = this.isSubscription ? "subscription" : "otp";
      }
      publish(PUB_SUB_EVENTS.sellingPlanUpdated, this.isSubscription)
    }
    
    handleSellingPlanUpdated(isSubscription) {
      const checkbox = this.querySelector(this.subscriptionSelector);
      if (checkbox && checkbox.checked !== isSubscription) {
        this.isUpdating = true;
        checkbox.checked = isSubscription;
        this.isSubscription = isSubscription;
        setTimeout(() => {
          this.isUpdating = false;
        }, 10);
      }
    }
  }

  customElements.define('td-byob-selling-plan', BundleSellingPlan)
}
